import { persistedQueryClient } from 'components/CacheableQueryClientProvider';
import { useOnAppResumed } from 'hooks/useOnAppResumed';
import { useCallback, useRef } from 'react';

const TIME_WINDOW_MS = 1000 * 60 * 5; // 5 minutes

export const useSyncAuthUser = (): void => {
  const lastFetchTimeRef = useRef(0);

  const handleAppResumed = useCallback(() => {
    const now = Date.now();
    const deltaMs = now - lastFetchTimeRef.current;
    if (deltaMs < TIME_WINDOW_MS) {
      return;
    }
    persistedQueryClient.invalidateQueries({ queryKey: ['auth-user'] });
    lastFetchTimeRef.current = now;
  }, []);

  useOnAppResumed(useCallback(() => handleAppResumed(), [handleAppResumed]));
};
